module.exports = __webpack_public_path__ + "img/circle.f7f14b58.svg";